import { render, staticRenderFns } from "./EventBannerList.vue?vue&type=template&id=1b1e0aa4&scoped=true"
import script from "./EventBannerList.vue?vue&type=script&lang=js"
export * from "./EventBannerList.vue?vue&type=script&lang=js"
import style0 from "./EventBannerList.vue?vue&type=style&index=0&id=1b1e0aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1e0aa4",
  null
  
)

export default component.exports